<div
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragHandle
  class="bg_{{ themeType }} grabbable"
>
  <h6>{{ displayWS().cache[loNameWS() ? 'alerts_on_loName' : 'alerts_on_the_same_terminal'] }}</h6>
  <button
    mat-icon-button
    mat-dialog-close
    [matTooltip]="displayWS().cache.close"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSourceWS()"
    matSort
    (matSortChange)="sort( $event )"
    [matSortDisableClear]="true"
    [matSortActive]="sortByColumnWS()"
    [matSortDirection]="sortByOrderWS()"
    id="test_al_list"
    class="stretch_w"
  >

    <ng-container matColumnDef="alStatus">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="alStatus"
        start="desc"
        id="test_al_list_sort_alStatus"
        style="width: 10em;"
      >{{ displayWS().cache.status }}</th>

      <td
        mat-cell
        *matCellDef="let row"
      >
        <mat-icon
          [svgIcon]="alStatusActionIcon[ row.alStatus ] || ''"
          [ngClass]="[ alStatusActionClass[ row.alStatus ] || '' ]"
          style="
            margin-right: .5em;
            display: inline-block;
            vertical-align: middle;
          "
        ></mat-icon>
        <span [ngClass]="{ text_weight_700: !+row.alStatus }">{{ displayWS().cache[ row.alStatusDisplay ] }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="atMinimumLevel">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="atMinimumLevel"
        start="desc"
        id="test_al_list_sort_atMinimumLevel"
        class="text_center"
        style="width: 10em;"
      >{{ displayWS().cache.level }}</th>

      <td
        mat-cell
        *matCellDef="let row"
      >
        <div
          class="atMinimumLevelDisplay"
          [ngClass]="{
            border_color_danger: +row.atMinimumLevel < 2,
            border_color_warn: 2 === +row.atMinimumLevel,
            border_color_primary: 3 === +row.atMinimumLevel,
            border_color_dark: 3 < +row.atMinimumLevel,
            text_weight_700: +row.atMinimumLevel < 4
          }"
        >{{ displayWS().cache[ row.atMinimumLevelDisplay ] }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="alDate">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="alDate"
        start="desc"
        id="test_al_list_sort_alDate"
      >{{ displayWS().cache.date }}</th>

      <td
        mat-cell
        *matCellDef="let row"
      >{{ row.alDateDisplay }}</td>
    </ng-container>

    <ng-container matColumnDef="alResolved">
      <th
        mat-header-cell
        *matHeaderCellDef
      >{{ displayWS().cache.duration }}</th>

      <td
        mat-cell
        *matCellDef="let row"
      >
        <span
          [matTooltip]="row.alResolvedDisplay"
          class="hoverable helps"
        >{{ row.alDurationDisplay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="alDetails">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="alDetails"
        start="desc"
        id="test_al_list_sort_alDetails"
      >{{ displayWS().cache.details }}</th>

      <td
        mat-cell
        *matCellDef="let row"
      >{{ row.alDetails }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th
        mat-header-cell
        *matHeaderCellDef
      ></th>

      <td
        mat-cell
        *matCellDef="let row"
      >
        <div style="
          display: grid;
          grid-auto-flow: column;
          justify-content: end;
          align-items: end;
          gap: .5em;
        ">
          @for (option of alStatusActionsSelectorSingle; track option) {
          @if ((+row.alStatus !== +option.value) && (+option.value > 0)) {

          <button
            (click)="handleActionOnSelection( { action: option.value, rows: [ row ] } )"
            mat-icon-button
            [disabled]="(1 === +option.value) && (2 === +row.atResolutionMode)"
            [matTooltip]="displayWS().cache[((1 === +option.value) && (2 === +row.atResolutionMode)) ? 'auto_resolution' : option.label]"
            [ngClass]="[ alStatusActionClass[ option.value ] || '' ]"
            [ngStyle]="{ cursor: ((1 === +option.value) && (2 === +row.atResolutionMode)) ? 'not-allowed' : 'pointer' }"
            type="button"
          >
            <mat-icon [svgIcon]="alStatusActionIcon[ option.value ]"></mat-icon>
          </button>

          }
          }

          @for (option of alStatusActionsSelectorSingle; track option) {
          @if (0 > +option.value) {

          <button
            (click)="handleActionOnSelection( { action: option.value, rows: [ row ] } )"
            mat-icon-button
            [disabled]="(1 === +option.value) && (2 === +row.atResolutionMode)"
            [matTooltip]="displayWS().cache[((1 === +option.value) && (2 === +row.atResolutionMode)) ? 'auto_resolution' : option.label]"
            [ngClass]="[ alStatusActionClass[ option.value ] || '' ]"
            [ngStyle]="{ cursor: ((1 === +option.value) && (2 === +row.atResolutionMode)) ? 'not-allowed' : 'pointer' }"
            type="button"
          >
            <mat-icon [svgIcon]="alStatusActionIcon[ option.value ]"></mat-icon>
          </button>

          }
          }
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumnListWS()"
    ></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumnListWS();"
    ></tr>
  </table>
</div>

<div
  mat-dialog-actions
  class="border_shadow_top_inset"
>
  <button
    mat-raised-button
    mat-dialog-close
    type="button"
  >{{ displayWS().cache.close }}</button>
</div>
